/* tslint:disable */
/* eslint-disable */
export enum InvoiceDeliveryTypeEnum {
  NotSet = 0,
  Mail = 1,
  Email = 2
}
